import CharField from "components/MeForm/CharField";

function CustomButtonWidget(props) {
  const { field } = props;
  const { Component, label, color, onClick } = field;

  return (
    <div className="col-span-2 p-2">
      {Component ? (
        <Component {...props} />
      ) : (
        <button
          className={`px-4 py-2 rounded ${color || "bg-blue-500"} text-white`}
          onClick={onClick}
        >
          {label || "Click"}
        </button>
      )}
    </div>
  );
}

export default CustomButtonWidget;
